import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type Category from "./Category";
import type SourceGroup from "./SourceGroup";

@Model()
class Forum extends ApplicationRecord {
  static jsonapiType = "forums";

  @Attr({ persist: false }) archivedAt: string;

  @BelongsTo() category: Category;

  @Attr() categoryId: number;

  @Attr({ persist: false }) createdAt: string;

  @Attr() domain: string;

  @Attr() locationId: number;

  @Attr() logoUrl: string;

  @Attr() name: string;

  @Attr() notes: string;

  @BelongsTo() sourceGroup: SourceGroup;

  @Attr() sourceGroupId: number;

  @Attr() timeZone: string;

  @Attr({ persist: false }) updatedAt: string;

  @Attr() url: string;

  @Attr() visible: boolean;
}

export default Forum;
